import Swiper from "swiper";
import { Navigation, EffectFade, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

// Parallax Effect
const carouselItems = document.querySelectorAll(
  ".home-main-swiper-parallax-container"
);

// Only initialize parallax if banner items exist
if (carouselItems.length > 0) {
  const scrollFactor = 0.25; // Adjust this between 0 (fixed) and 1 (normal scrolling)

  const updatePosition = () => {
    const offset = window.scrollY * scrollFactor;
    carouselItems.forEach((item) => {
      const swiperInstance = item.querySelector(".home-main-swiper"); // Fix: Add dot for class selector
      if (swiperInstance) {
        // Apply a translation to the image to simulate the parallax effect
        swiperInstance.style.transform = `translate3d(0, ${offset}px, 0)`; // Use translate3d for better performance
      }
    });
  };

  // Set initial image position
  updatePosition();

  // Update image position on scroll
  window.addEventListener("scroll", updatePosition);
}

document.addEventListener("DOMContentLoaded", function () {
  const swiperElements = document.querySelectorAll(".home-main-swiper");
  let firstImageLoaded = false;

  if (swiperElements.length > 0) {
    swiperElements.forEach((element) => {
      new Swiper(element, {
        modules: [Navigation, EffectFade, Autoplay],
        navigation: {
          nextEl: element.querySelector(".swiper-button-next"),
          prevEl: element.querySelector(".swiper-button-prev"),
        },
        slidesPerView: 1,
        centeredSlides: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        loop: true,
        on: {
          init: function (swiper) {
            // Check if first slide image exists
            const firstSlide = swiper.slides[0];
            if (firstSlide) {
              const firstImage = firstSlide.querySelector("img");
              if (firstImage) {
                // If image is already loaded
                if (firstImage.complete) {
                  if (!firstImageLoaded) {
                    firstImageLoaded = true;
                    document.dispatchEvent(new Event("firstSwiperImageLoaded"));
                    console.log(
                      "First swiper image was already loaded, event dispatched"
                    );
                  }
                } else {
                  // Wait for image to load
                  firstImage.addEventListener("load", function () {
                    if (!firstImageLoaded) {
                      firstImageLoaded = true;
                      document.dispatchEvent(
                        new Event("firstSwiperImageLoaded")
                      );
                      console.log(
                        "First swiper image loaded, event dispatched"
                      );
                    }
                  });
                }
              }
            }
          },
        },
      });
    });
  }
});
